// ============================================================================
// CHINESE (SIMPLIFIED) TRANSLATIONS - BIBLE FACTS
// ============================================================================
// 关于圣经的有趣事实

export const bibleFacts = [
  {
    category: "结构",
    text: "圣经包含66卷书，由40多位不同作者在大约1500年的时间里写成",
    source: "圣经正典结构"
  },
  {
    category: "篇幅",
    text: "圣经原文包含31,173节经文、1,189章和大约783,137个词",
    source: "圣经文本分析"
  },
  {
    category: "翻译",
    text: "圣经已被完整或部分翻译成3,000多种语言，使其成为世界上翻译最多的书籍",
    source: "联合圣经公会"
  },
  {
    category: "经文",
    text: "圣经最短的经文是'耶稣哭了'（约翰福音11:35），最长的是以斯帖记8:9",
    source: "圣经文本分析"
  },
  {
    category: "流行度",
    text: "圣经是有史以来最畅销的书籍，已发行超过50亿册",
    source: "出版记录"
  },
  {
    category: "历史",
    text: "1947年发现的死海古卷包含2000多年前的圣经手稿",
    source: "圣经考古学"
  },
  {
    category: "中心",
    text: "圣经的中心章节是诗篇118篇，中心经文是诗篇118:8",
    source: "圣经数字结构"
  }
];

export default bibleFacts;
